import styled, { keyframes } from 'styled-components';

const scale = keyframes`
  0% {
    transform: scaley(0.4)
  }
  50% {
    transform: scaley(1)
  }
  100% {
    transform: scaley(0.4)
  }
`;

export const Bar = styled.span`
  background-color: ${({ theme }) => theme.COLORS.NEUTRAL_20};
  width: ${({ width }) => width};
  height: ${({ height }) => height};
  margin: ${({ margin }) => margin};
  border-radius: ${({ borderRadius }) => borderRadius};
  display: inline-block;
  animation: ${scale} ${({ speedMultiplier }) => 1 / speedMultiplier}s
    ${({ position }) => position * 0.1}s infinite
    cubic-bezier(0.2, 0.68, 0.18, 1.08);
  animation-fill-mode: both;
`;

export default {};
